function TeamCard({ name, role, img, link }) {
	return (
		<div>
			<div className="mb-team-booking-card mb-1">
				<a href={link} target="_blank" rel="noreferrer">
					<div className="mb-team-booking-overlay">
						<div className="mb-team-booking-overlay-content">
							<p>Book Now</p>
						</div>
					</div>
				</a>
				<img src={img} alt={name + " photo"} className="mb-team-headshot-img img-fluid mb-3" />
			</div>
			<h4 className="mb-0">{name}</h4>
			<p className="mb-0 secondary-font">{role}</p>
		</div>
	);
}

export default TeamCard;
